import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemSolution from './components/ProblemSolution';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import WhoItsForSection from './components/WhoItsForSection';
import TestimonialsSection from './components/TestimonialsSection';
import SecondaryCtaSection from './components/SecondaryCtaSection';
import FooterSection from './components/FooterSection';
import PricingPage from './PricingPage'; // Import the new PricingPage
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import routing components
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <HeroSection />
              <ProblemSolution />
              <FeaturesSection />
              <HowItWorksSection />
              <WhoItsForSection />
              <TestimonialsSection />
              <SecondaryCtaSection />
            </>
          } />
          <Route path="/pricing" element={<PricingPage />} />
        </Routes>
        <FooterSection />
      </div>
    </Router>
  );
};

export default App;
